import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { VendorContextService } from './vendor-context.service';

/** Must match VendorPortalEndpoints.CompanyHeader on the API. */
export const VENDOR_COMPANY_HEADER = 'X-Vendor-Company';

/**
 * Vendor Portal requests carry the company picked in the portal's top bar, so the API narrows Home,
 * Calendar, Work Orders, Parts and Reports to it. No header = all of the vendor's companies.
 */
export const vendorCompanyInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('/api/vendor-portal/')) return next(req);
  const companyId = inject(VendorContextService).companyId();
  return next(companyId ? req.clone({ setHeaders: { [VENDOR_COMPANY_HEADER]: companyId } }) : req);
};
